import { Title } from "../../../../../components/Title";
import claimPayIcon from '../../../../../assets/claim-pay-icon.svg';

export const PropAddressTitle = () => <Title title='Property Address'>
  <img alt='claimpay' src={claimPayIcon} />
</Title>